var _defs, _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmithSolarLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    "data-name": "Laag 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 541.11 155.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff5000;}.cls-2{fill:#1d1719;}.cls-3{fill:#1d1d1b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,0V47.6H61.67A78.83,78.83,0,0,0,0,0ZM27.34,107.53H99.67a78.25,78.25,0,0,0,5.67-25.76h-78ZM81.27,51.94H8.48V77.43H85.67A78.88,78.88,0,0,0,81.27,51.94ZM0,155.93a78.8,78.8,0,0,0,60.08-44.06H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M290.69,88.25l2.57-.22a5.82,5.82,0,0,0,.86,2.56,4.65,4.65,0,0,0,2.08,1.61,7.8,7.8,0,0,0,3.16.61,7.5,7.5,0,0,0,2.75-.47,3.77,3.77,0,0,0,1.78-1.28,3,3,0,0,0,.58-1.77,2.6,2.6,0,0,0-.57-1.7A4.19,4.19,0,0,0,302,86.39a34.51,34.51,0,0,0-3.67-1,19.07,19.07,0,0,1-4-1.29,5.63,5.63,0,0,1-2.2-1.93,4.75,4.75,0,0,1-.72-2.57,5.27,5.27,0,0,1,.88-2.92,5.57,5.57,0,0,1,2.59-2.07,9.93,9.93,0,0,1,3.79-.7,10.22,10.22,0,0,1,4,.74,5.86,5.86,0,0,1,2.7,2.18,6.28,6.28,0,0,1,1,3.26l-2.62.2a4.29,4.29,0,0,0-1.43-3,5.54,5.54,0,0,0-3.59-1,5.78,5.78,0,0,0-3.61.91,2.77,2.77,0,0,0-1.14,2.19,2.39,2.39,0,0,0,.81,1.83c.52.49,1.9,1,4.11,1.47A26.66,26.66,0,0,1,303.57,84a6.18,6.18,0,0,1,2.66,2.1,5,5,0,0,1,.86,2.94,5.54,5.54,0,0,1-.94,3.1,6.21,6.21,0,0,1-2.7,2.26,9.42,9.42,0,0,1-4,.81,11.84,11.84,0,0,1-4.69-.81,6.54,6.54,0,0,1-3-2.46A7.07,7.07,0,0,1,290.69,88.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M310.77,94.9V74.25h4.1l4.91,14.63c.44,1.36.77,2.37,1,3.06.23-.75.6-1.86,1.1-3.31l5-14.38h3.66V94.9h-2.64V77.62l-6,17.29h-2.45l-6-17.59V94.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M335.33,94.9V74.25h2.72V94.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348.14,94.91V76.69h-6.81V74.26H357.7v2.43h-6.83V94.91Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M360.62,94.9V74.25h2.73v8.49h10.71V74.25h2.73V94.9h-2.72V85.17H363.34V94.9Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 121.6,
    y: 110.43,
    width: 419.51,
    height: 2.88
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M404,80.53c-.14-3.13-2.74-4.12-5-4.12-1.72,0-4.63.48-4.63,3.56,0,1.72,1.21,2.29,2.4,2.57l5.79,1.33c2.63.62,4.6,2.2,4.6,5.42,0,4.8-4.46,6.13-7.93,6.13-3.75,0-5.22-1.13-6.13-1.95A6.24,6.24,0,0,1,391,88.33h2.57c0,3.67,3,4.74,5.59,4.74,2,0,5.31-.51,5.31-3.42,0-2.12-1-2.8-4.32-3.59l-4.15-1c-1.33-.31-4.32-1.24-4.32-4.77,0-3.16,2.06-6.27,7-6.27,7.09,0,7.79,4.24,7.91,6.47Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M419.48,95.41c-7.57,0-9.88-6.3-9.88-10.67s2.32-10.67,9.88-10.67,9.88,6.3,9.88,10.67S427,95.41,419.48,95.41Zm0-18.92c-4.4,0-7.06,3.47-7.06,8.24S415.08,93,419.48,93s7.06-3.47,7.06-8.24S423.88,76.5,419.48,76.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M435.35,92.45h10.28v2.43h-13V74.6h2.74Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M451.5,89l-2.12,5.9h-2.82l7.62-20.27h3.11l7.34,20.27h-3l-2-5.9Zm7.14-2.43-3-8.92h-.06l-3.25,8.92Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M470.22,94.88h-2.74V74.6h9.37c3.33,0,6.66,1.16,6.66,5.45a5,5,0,0,1-2.82,4.86c1.16.48,2.32,1,2.43,3.81l.17,3.67c0,1.13.17,1.55,1,2v.45h-3.36a24.84,24.84,0,0,1-.48-5.08c0-1.67-.34-3.61-3.61-3.61h-6.64Zm0-11h6.35c2,0,4.12-.51,4.12-3.5s-2.29-3.39-3.64-3.39h-6.83Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M495.32,74.6h8.92c3.78,0,5.73,2.34,5.73,5.11a4.46,4.46,0,0,1-2.71,4.24c1.33.54,3.67,1.47,3.67,4.94,0,3.25-2.4,6-6.89,6h-8.72Zm2.74,8.58H503c2.63,0,4.24-.79,4.24-3.28,0-1.89-1.16-3-4.21-3h-5Zm0,9.35h5.84c2.85,0,4.29-1.44,4.29-3.7,0-2.85-2.51-3.42-4.74-3.42h-5.39Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M516.9,94.88H514v-3h2.94Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M534.55,74.6h3.08l-7.4,20.27h-2.91l-7.4-20.27h3l5.79,17.28h.06Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M540.05,94.88h-2.94v-3h2.94Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmithSolarLogo);
export default __webpack_public_path__ + "static/media/smith-solar-logo.a1bc2373cf9399f67cd9742ea8afa6f6.svg";
export { ForwardRef as ReactComponent };